/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m30.447 15.1057c.339.169.553.515.553.894s-.214.725-.553.895l-28 14c-.141.07-.294.105-.447.105-.183 0-.365-.05-.526-.149-.294-.182-.474-.504-.474-.851v-28c0-.347.18-.668.474-.85.295-.183.663-.199.973-.044zm-27.447 13.276 24.764-12.382-24.764-12.382z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;